import { render, staticRenderFns } from "./myGacha.vue?vue&type=template&id=4b47bd0d&scoped=true&"
import script from "./myGacha.vue?vue&type=script&lang=js&"
export * from "./myGacha.vue?vue&type=script&lang=js&"
import style0 from "./myGacha.vue?vue&type=style&index=0&id=4b47bd0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b47bd0d",
  null
  
)

export default component.exports